import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { UploadFileBlobLink } from '@/components/ui/Form/UploadFile/UploadFileBlobLink';
import { UploadFileButton } from '@/components/ui/Form/UploadFile/UploadFileButton';
/**
 * ファイル共有メッセージ：フォーム内でアップロードファイルを表示するためのボタンコンポーネント
 * @param props
 * @constructor
 */
export const FormFileLinkButton = (props) => {
    const { className = '', onClickLink, renderProps } = props;
    if (renderProps.inputFile) {
        // ファイル実体がある場合（ユーザーの操作によってファイルアップロードされた直後は、blobでそのまま表示する）
        return (_jsx(UploadFileBlobLink, { className: className, file: renderProps.inputFile, hasUploadError: renderProps.invalid, isDeletable: true, isUploading: renderProps.loading, onClickDelete: renderProps.onClickDelete }));
    }
    // ファイル実体がない場合（API経由でIDを使ってセキュアなDLを行う）
    return (_jsx(UploadFileButton, { className: className, fileName: renderProps.fieldValue.name || '', hasUploadError: renderProps.invalid, id: renderProps.fieldValue.rfp_share_document_message_file_id, isDeletable: true, isUploading: renderProps.loading, onClickDelete: renderProps.onClickDelete, onClickLink: onClickLink }));
};
